import React from 'react';

import Image from 'next/image';

import { core } from './localization/core';

const Footer = () => {
  return (
    <div className="flex flex-col items-center justify-center mt-3 absolute bottom-0 w-full">
      <p>{core.footer}</p>
      <Image src="/img/v2/SponsorLine/sponsorsLine.png" alt="Logo" width={400} height={100} />
      <p className="text-xs text-sivarbet-third-text mt-3 text-center">{core.copy}</p>
    </div>
  );
};

export default Footer;
